import { gql } from '@apollo/client';

export const DeleteFusionEventMutation = gql`
  mutation DeleteFusionEvent($fusionEventId: String!) {
    deleteFusionEvent(fusionEventId: $fusionEventId) 
  }
`;
